<template>
    <div class="row position-relative">
        <div class="col-md-3 ribbon">
    <span class="ribbon3 text-center">
      <span>{{ this.title }}</span>
    </span>
        </div>
        <div class="col-md ml-auto">
            <div style="left: 3rem;z-index: 1;top: 1.8rem;" :style="{
                'min-width':tutorialExists ? '5rem' :''
            }" class="float-right position-absolute justify-content-between d-flex">
                <button v-if="tutorialExists" v-b-tooltip.hover="'راهنما'" @click="getTutorial">
                    <i class="fa fa-question text-primary"></i>
                </button>

                <button v-b-tooltip.hover="'بازگشت به صفحه قبلی'" @click="$router.back()">
                    <i class="fa fa-times text-danger"></i>
                </button>
            </div>

            <v-dialog v-model="dialog" scrollable max-width="800px">
                <v-card elevation="2" outlined>
                    <v-toolbar>
                        <v-tabs v-model="tab" align-with-title grow>
                            <v-tab>
                                <v-icon>mdi-account</v-icon>
                                کاربر
                            </v-tab>

                            <v-tab v-if="can('admin_access')">
                                <v-icon>mdi-shield-account-outline</v-icon>
                                ادمین
                            </v-tab>
                        </v-tabs>
                    </v-toolbar>

                    <b-card-text class="m-0">
                        <v-tabs-items v-model="tab">
                            <v-tab-item>
                                <v-card v-if="tutorial">
                                    <v-card-title class="justify-content-center">{{ tutorial.title }}</v-card-title>

                                    <v-card-text v-html="tutorial.description"></v-card-text>
                                </v-card>
                            </v-tab-item>

                            <v-tab-item>
                                <v-card v-if="adminTutorial">
                                    <v-card-title class="justify-content-center">{{ adminTutorial.title }}</v-card-title>

                                    <v-card-text v-html="adminTutorial.description"></v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </b-card-text>

                    <v-card-actions class="justify-end" style="background: white; z-index: 999">
                        <v-btn outlined class="mr-auto btn-cancel" text @click="dialog = false">
                            <v-icon>mdi-close-circle</v-icon>
                            <b>بستن</b>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import axios from "axios";

let coreland = process.env.VUE_APP_CoreLandUrl;

export default {
    name: "titleRibbon",
    props: {
        title: {
            default: 'مدیریت آگهی تبلیغاتی'
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            hasNoTutorials: false,
            tutorialExists: false,
            content: [
                {
                    title: "",
                    description: ""
                }
            ],
            tab: null,
            tutorial: null,
            adminTutorial: null,
        }
    },
    methods: {
        ...mapActions('tutorial', [
            'setTutorials',
        ]),
        goToCore() {
            this.$router.go(-1)
        },
        getTutorial() {
            this.$modal.showLoading();
            this.requestApiPost(`contentTutorial`, {slug: this.$route.path.substring(1)})
                .then(({data}) => {
                    for (let a of data) {
                        if (a.privilege_type === 'admin') {
                            this.adminTutorial = a
                        } else {
                            this.tutorial = a
                        }
                    }
                })
                .catch(({response}) => this.hasNoTutorials = true)
                .finally(() => {
                    this.dialog = true
                    this.$modal.hideLoading();
                })
        },
        requestApiPost(uri, data = {}) {
            return axios.post(`${coreland + '/api'}/${uri}`, data, {
                headers: this.header(),
            });
        },
        header() {
            const token = localStorage.getItem("id_token");

            return {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json',
            };
        },
    },
    computed: {
        ...mapGetters('tutorial', [
            'tutorials',
        ]),
    },
    watch: {
        tutorials: {
            immediate: true,
            deep: true,
            handler(val) {
                this.$watch("$route", (to) => {
                    this.tutorialExists = this.tutorials.indexOf(to.path.substring(1)) > -1
                }, {
                    immediate: true,
                    deep: true
                });
            }
        },
    },
}
</script>

<style scoped>
.ribbon {
    width: 100%;
    float: right;
    margin-bottom: 0;
    text-transform: uppercase;
    color: white;
    z-index: 1;

}

.ribbon:nth-child(even) {
    margin-right: 4%;
}

@media (max-width: 500px) {
    .ribbon {
        width: 100%;
    }

    .ribbon:nth-child(even) {
        margin-right: 0%;
    }
}

.ribbon3 {
    width: 200px;
    height: 50px;
    line-height: 50px;
    padding-left: 15px;
    position: absolute;
    right: -1px;
    top: 30px;
    background: rgb(238, 49, 138);
}

.ribbon3:before, .ribbon3:after {
    content: "";
    position: absolute;
}

.ribbon3:before {
    height: 0;
    width: 0;
    top: -7.5px;
    right: 0;
    border-bottom: 9px solid black;
    border-left: 9px solid transparent;
}

.ribbon3:after {
    height: 0;
    width: 0;
    left: -14.5px;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
    border-right: 15px solid rgb(238, 49, 138);

}
</style>